import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';
import { TrackedOrder } from '../../../core/model';
import { ORDER_CORE_FEATURE } from '../store/order-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: OrderTrackingFacade,
      feature: ORDER_CORE_FEATURE,
      async: true,
      methods: ['trackOrder', 'getTrackOrderLoading', 'getTrackOrderLoaded'],
    }),
})
export abstract class OrderTrackingFacade {
  abstract trackOrder(orderCode: string): Observable<TrackedOrder | undefined>;
  abstract getTrackOrderLoading(orderCode: string): Observable<boolean>;
  abstract getTrackOrderLoaded(orderCode: string): Observable<boolean>;
}
